import apiClient from './apiClient';

export const getProducers = async () => {
    try {
        const response = await apiClient.get('/producer');
        return response.data;
    } catch (error) {
        console.log(error)
        throw new Error(error.response?.data?.error || error.message)
    }
};